import React from 'react'

export default function NormalSubmit({ text, theme, className, onClick }) {
  return (
    <>
      {
        theme ?
          <button onClick={onClick} type='submit' className={`${className} bg-theme hover:bg-teal-700 text-white font-semibold py-2 px-4 border border-white hover:border-transparent rounded`}>
            {text}
          </button>
          :
          <button onClick={onClick} type='submit' className={`${className} bg-slate-600 hover:bg-slate-700 text-white font-semibold py-3 px-4 border border-white hover:border-transparent rounded-xl`}>
            {text}
          </button>
      }
    </>
  )
}
